<template>
  <header class="relative">
    <div class="mx-auto max-w-2xl px-4 py-5 text-center">
      <div class="flex items-center justify-center gap-2">
        <LockIcon class="size-5 shrink-0 text-primary" aria-hidden="true" />
        <h1 class="text-xl font-semibold text-foreground">{{ $t('header.title') }}</h1>
      </div>
      <p class="mt-1 text-sm text-muted-foreground">{{ $t('header.subtitle') }}</p>
    </div>
    <div class="absolute right-4 top-4 flex items-center gap-1 rounded-lg border border-border bg-muted/50 p-1">
      <button
        type="button"
        :class="['rounded-md px-3 py-1.5 text-sm font-medium transition-colors', locale === 'it' ? 'bg-primary text-primary-foreground' : 'text-muted-foreground hover:text-foreground']"
        @click="setLocale('it')"
      >
        IT
      </button>
      <button
        type="button"
        :class="['rounded-md px-3 py-1.5 text-sm font-medium transition-colors', locale === 'en' ? 'bg-primary text-primary-foreground' : 'text-muted-foreground hover:text-foreground']"
        @click="setLocale('en')"
      >
        EN
      </button>
    </div>
  </header>
</template>

<script>
import { LockIcon } from 'lucide-vue-next'
import { useI18n } from 'vue-i18n'

export default {
  name: 'HeaderApp',
  components: { LockIcon },
  setup() {
    const { locale } = useI18n()
    const setLocale = (lang) => {
      locale.value = lang
      if (typeof localStorage !== 'undefined') localStorage.setItem('locale', lang)
    }
    return { locale, setLocale }
  }
}
</script>
